import { graphql } from "@/graphql/generated/gql";

export const loginMutationDocument = graphql(/* GraphQL */ `
  mutation login($input: LoginInput!) {
    login(loginInput: $input) {
      __typename
      ... on AuthEntity {
        token
      }
      ... on Requires2FAResponse {
        requires2FA
        twoFactorToken
        message
      }
      ... on SetupRequiredResponse {
        status
        message
        tempToken
      }
      ... on RequiresFederatedLoginResponse {
        requiresFederatedLogin
        startUrl
      }
    }
  }
`);

export const discoverLoginMethodMutationDocument = graphql(/* GraphQL */ `
  mutation discoverLoginMethod($input: DiscoverLoginMethodInput!) {
    discoverLoginMethod(discoverLoginMethodInput: $input) {
      method
      startUrl
    }
  }
`);

export const refreshAccessTokenMutationDocument = graphql(/* GraphQL */ `
  mutation refresh {
    refresh {
      token
    }
  }
`);

export const requestPasswordResetLinkMutationDocument = graphql(/* GraphQL */ `
  mutation requestPasswordResetLink($input: PasswordResetLinkRequestInput!) {
    requestPasswordResetLink(passwordResetLinkRequestInput: $input) {
      success
      email
      message
    }
  }
`);

export const checkPasswordResetTokenMutationDocument = graphql(/* GraphQL */ `
  mutation checkPasswordResetToken($input: PasswordResetTokenCheckInput!) {
    checkPasswordResetToken(passwordResetTokenCheckInput: $input) {
      success
      email
      message
    }
  }
`);

export const updatePasswordWithTokenMutationDocument = graphql(/* GraphQL */ `
  mutation updatePasswordWithToken($input: PasswordUpdateWithTokenInput!) {
    updatePasswordWithToken(passwordUpdateWithTokenInput: $input) {
      success
      email
      message
    }
  }
`);

export const request2FAResetLinkMutationDocument = graphql(/* GraphQL */ `
  mutation request2FAResetLink($input: TwoFactorAuthResetLinkRequestInput!) {
    request2FAResetLink(twoFactorAuthResetLinkRequestInput: $input) {
      success
      email
      message
    }
  }
`);

export const check2FAResetTokenMutationDocument = graphql(/* GraphQL */ `
  mutation check2FAResetToken($input: TwoFactorAuthResetTokenCheckInput!) {
    check2FAResetToken(twoFactorAuthResetTokenCheckInput: $input) {
      success
      email
      message
    }
  }
`);

export const reset2FAWithTokenMutationDocument = graphql(/* GraphQL */ `
  mutation reset2FAWithToken($input: Reset2FAWithTokenInput!) {
    reset2FAWithToken(reset2FAWithTokenInput: $input) {
      success
      email
      message
    }
  }
`);
